import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getClubExpenseStatement } from '../../../api/ClubExpensesAPI';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';

const ClubExpenseStatementPage = () => {
    const { expenseId } = useParams();
    const [statement, setStatement] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getClubExpenseStatement(expenseId, (data) => {
            setIsLoading(false);
            if (data.expense_details) {
                setStatement(data);
            } else {
                Swal.fire('Error!', 'Could not fetch statement data.', 'error');
            }
        });
    }, [expenseId]);

    if (isLoading) return <div className="text-center p-5"><div className="spinner-border"></div></div>;
    if (!statement) return <div className="text-center p-5">Statement data could not be loaded.</div>;

    const { expense_details, summary, line_items } = statement;

    return (
        <>
            {/* Print styles - same as ContributionStatementPage */}
            <style type="text/css" media="print">{/* ... */}</style>
            <main>
                <div className="container-fluid">
                    <div className="breadcrumb-container">
                        <AppBreadCrumb title={`Expense Statement for ${expense_details.date}`} />
                    </div>
                    
                    <div className="card">
                        <div className="card-header">
                            <h4 className="mb-0">Club Expense Statement</h4>
                            <strong>{expense_details.description}</strong>
                        </div>
                        <div className="card-body">
                            {/* Summary Section */}
                            <div className="row justify-content-end mb-4">
                                <div className="col-md-5">
                                    <h5>Summary</h5>
                                    <table className="table">
                                        <tbody>
                                            <tr><td>Date:</td><td className="text-end">{expense_details.date}</td></tr>
                                            <tr><td>Account Head:</td><td className="text-end">{expense_details.head_of_account}</td></tr>
                                            <tr><td>Total Members:</td><td className="text-end">{summary.total_members}</td></tr>
                                            <tr className="table-secondary">
                                                <td className="fw-bold">Total Amount:</td>
                                                <td className="text-end fw-bold">₹{expense_details.total_amount}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            {/* Breakdown Section */}
                            <h5>Contributions Breakdown</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Member Name</th>
                                            <th>Paid By</th>
                                            <th className="text-end">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {line_items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.member_name}</td>
                                                <td>{item.paid_by}</td>
                                                <td className="text-end">₹{parseFloat(item.amount).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-footer text-end print-button-container">
                            <button className="btn btn-primary" onClick={() => window.print()}>
                                <i className="bi bi-printer me-2"></i>Print Statement
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default ClubExpenseStatementPage;